module.exports = __webpack_public_path__ + "img/AlternateEmailOutlined.92fc65e6.svg";